/* ============================================================
   Silly Onesie — fiche produit et panier
   ============================================================
   Aucun prix n est calcule ici : les montants viennent des variantes
   Shopify (page) et de /cart.js (panier). La taille n est jamais choisie
   a la place du client : sans taille, l ajout et le paiement express
   demandent d abord d en choisir une.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("os");
  if (!root) return;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var DATA = {};
  try { DATA = JSON.parse($("[data-os-product]", root).textContent); } catch (e) { return; }
  var CI = DATA.colorIndex, SI = DATA.sizeIndex;
  var form = document.getElementById("os-form");
  var idField = $("[data-os-variant]", root);

  /* ------------------------------------------------------------ outils */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = DATA.moneyFormat || "${{amount}}";
    return f
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
  }

  function annoncer(t) { var z = $("[data-os-live]", root); if (z) z.textContent = t; }

  function jours(n) {
    /* n jours ouvres a partir d aujourd hui (samedi et dimanche exclus) */
    var d = new Date(); var k = n;
    while (k > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k--; }
    return d;
  }
  function court(d) {
    try { return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
    catch (e) { return (d.getMonth() + 1) + "/" + d.getDate(); }
  }
  function fenetre(min, max) {
    min = parseInt(min, 10); max = parseInt(max, 10);
    if (isNaN(min) || isNaN(max) || max < min) return null;
    return court(jours(min)) + " – " + court(jours(max));
  }

  /* ---------------------------------------------------------- variantes */
  var couleur = ($("input[name='os-color']:checked", root) || {}).value || null;
  var taille = ($("input[name='os-size']:checked", root) || {}).value || null;

  /* Offre 2 onesies : chaque onesie a sa couleur et sa taille. La couleur
     du n°2 suit celle du n°1 tant que le client ne l a pas changee ; sa
     taille n est jamais choisie a sa place. */
  var duoBox = $("[data-os-duo]", root);
  var DUO = duoBox ? Math.round(parseFloat(duoBox.getAttribute("data-price")) * 100) : 0;
  if (!(DUO > 0)) DUO = 0;
  var pack = (($("input[name='os-pack']:checked", root) || {}).value === "2") ? 2 : 1;
  var couleur2 = null, couleur2Libre = false;
  var taille2 = ($("input[name='os-size-2']:checked", root) || {}).value || null;
  var qtyField = $("[data-os-qty]", root);
  var xpExtra = $("[data-os-xp-extra]", root);

  function duo() { return pack === 2 && DUO > 0; }

  function variante(c, t) {
    for (var i = 0; i < DATA.variants.length; i++) {
      var v = DATA.variants[i];
      if (v.options[CI] === c && (t === null || v.options[SI] === t)) return v;
    }
    return null;
  }

  function courante() { return variante(couleur, taille) || variante(couleur, null) || DATA.variants[0]; }
  function seconde() {
    var c = couleur2 || couleur;
    return variante(c, taille2) || variante(c, null) || DATA.variants[0];
  }

  function majTaille(t, sl, hint, fs, vide) {
    if (t) {
      if (sl) sl.textContent = t;
      if (hint) { hint.textContent = "Fits " + (DATA.sizes[t] || ""); hint.classList.add("is-set"); }
      if (fs) fs.classList.remove("need");
    } else if (sl && !(fs && fs.classList.contains("need"))) {
      sl.textContent = vide;
    }
  }

  /* Paiement express : le formulaire porte le onesie n°1 ; le n°2 part en
     article supplementaire (shopify-additional-items, index a partir de 1),
     ou en quantite 2 si c est exactement la meme variante. */
  function majExpress(v, v2) {
    if (qtyField) qtyField.value = "1";
    if (!xpExtra) return;
    xpExtra.innerHTML = "";
    if (!v || !v2) return;
    if (v2.id === v.id) { if (qtyField) qtyField.value = "2"; return; }
    xpExtra.innerHTML =
      '<input type="hidden" name="shopify-additional-items[1][id]" value="' + v2.id + '">' +
      '<input type="hidden" name="shopify-additional-items[1][quantity]" value="1">';
  }

  function majPage(defiler) {
    var v = courante();
    if (idField && v) idField.value = v.id;
    var d = duo();

    var cl = $("[data-os-color-label]", root); if (cl) cl.textContent = couleur || "";
    majTaille(taille, $("[data-os-size-label]", root), $("[data-os-size-hint]", root), $("[data-os-sizes]", root), "Choose your size");

    /* Onesie n°2 */
    $$("[data-os-duo-h]", root).forEach(function (h) { h.hidden = !d; });
    var box2 = $("[data-os-duo2]", root); if (box2) box2.hidden = !d;
    var v2 = null;
    if (d) {
      if (!couleur2Libre) {
        couleur2 = couleur;
        $$("input[name='os-color-2']", root).forEach(function (x) { x.checked = x.value === couleur; });
      }
      v2 = seconde();
      var cl2 = $("[data-os-color2-label]", root); if (cl2) cl2.textContent = couleur2 || "";
      majTaille(taille2, $("[data-os-size2-label]", root), $("[data-os-size2-hint]", root), $("[data-os-sizes2]", root), "Choose a size");
    }
    if (form) form.classList.toggle("need-size", !taille || (d && !taille2));

    /* Prix : un onesie = prix de la variante ; deux = prix de l offre, avec
       en reference le vrai prix de deux onesies achetes separement. */
    var unite = v ? v.price : 0;
    var plein = unite + (v2 ? v2.price : unite);
    var total = d ? DUO : unite;
    var p1 = $("[data-os-price]", root); if (p1) p1.textContent = money(total);
    var was = $("[data-os-was]", root);
    var save = $("[data-os-save]", root);
    if (was) { was.hidden = !(d && plein > total); was.textContent = money(plein); }
    if (save) { save.hidden = !(d && plein > total); save.textContent = "Save " + money(plein - total); }
    var k1 = $("[data-os-pack1]", root); if (k1) k1.textContent = money(unite);
    var k2 = $("[data-os-pack2-was]", root); if (k2) k2.textContent = money(unite * 2);
    var k3 = $("[data-os-pack2-save]", root); if (k3) k3.textContent = "Save " + money(unite * 2 - DUO);
    var p2 = $("[data-os-add-amt]", root); if (p2) p2.textContent = "— " + money(total);
    var p3 = $("[data-os-sticky-price]", root);
    if (p3) p3.textContent = money(total) + (d ? " · 2 onesies" : (couleur ? " · " + couleur : ""));
    var si = $("[data-os-sticky-img] img", root); if (si && v && v.image) si.src = v.image;

    var dispo = (!v || v.available) && (!v2 || v2.available);
    var lib = dispo ? (d ? "Add 2 to cart" : "Add to cart") : "Sold out";
    var add = $("[data-os-add]", root);
    if (add) { add.disabled = !dispo; $("[data-os-add-label]", add).textContent = lib; }
    var sa = $("[data-os-sticky-add]", root); if (sa) sa.textContent = d ? "Add 2" : "Add to cart";

    majExpress(v, v2);
    if (defiler && v && v.media) allerA(v.media - 1);
  }

  /* n = 1 : taille du onesie n°1 ; n = 2 : taille du onesie n°2. */
  function tailleManquante() {
    if (!taille) return 1;
    if (duo() && !taille2) return 2;
    return 0;
  }

  function demanderTaille(n) {
    var deux = n === 2;
    var fs = $(deux ? "[data-os-sizes2]" : "[data-os-sizes]", root);
    var grille = fs && $(".os-sizes", fs);
    if (fs) {
      fs.classList.add("need");
      var sl = $(deux ? "[data-os-size2-label]" : "[data-os-size-label]", root);
      if (sl) sl.textContent = "Please choose a size";
      fs.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (grille) { grille.classList.remove("shake"); void grille.offsetWidth; grille.classList.add("shake"); }
    var premier = $("input[name='" + (deux ? "os-size-2" : "os-size") + "']", root);
    if (premier) setTimeout(function () { premier.focus({ preventScroll: true }); }, 350);
    annoncer(deux ? "Please choose a size for onesie #2." : "Please choose a size first.");
  }

  root.addEventListener("change", function (e) {
    var n = e.target.name;
    if (n === "os-color") { couleur = e.target.value; majPage(true); }
    if (n === "os-size") { taille = e.target.value; majPage(false); }
    if (n === "os-pack") { pack = e.target.value === "2" ? 2 : 1; majPage(false); }
    if (n === "os-color-2") { couleur2 = e.target.value; couleur2Libre = true; majPage(false); }
    if (n === "os-size-2") { taille2 = e.target.value; majPage(false); }
  });

  /* ------------------------------------------------------------ galerie */
  var track = $("[data-os-track]", root);
  var dots = $$("[data-os-dots] i", root);
  function allerA(i) {
    if (!track) return;
    var s = track.children[i];
    if (s) track.scrollTo({ left: s.offsetLeft, behavior: "smooth" });
  }
  function majDots() {
    if (!track || !dots.length) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
  }
  if (track) { track.addEventListener("scroll", function () { requestAnimationFrame(majDots); }, { passive: true }); majDots(); }

  /* Personnages : un clic choisit la couleur et remonte a l achat. */
  $$("[data-os-pick]", root).forEach(function (b) {
    b.addEventListener("click", function () {
      var val = b.getAttribute("data-os-pick");
      var r = $$("input[name='os-color']", root).filter(function (x) { return x.value === val; })[0];
      if (r) { r.checked = true; couleur = val; majPage(true); }
      var g = $(".os-buy", root); if (g) g.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
  $$("[data-os-scroll-buy]", root).forEach(function (b) {
    b.addEventListener("click", function () { var g = $(".os-buy", root); if (g) g.scrollIntoView({ behavior: "smooth", block: "start" }); });
  });

  /* ------------------------------------------------------------- ajout */
  var occupe = false;
  function ajouter() {
    var manque = tailleManquante();
    if (manque) { demanderTaille(manque); return; }
    var v = courante();
    if (!v || occupe) return;
    var items = [{ id: v.id, quantity: 1 }];
    if (duo()) {
      var v2 = seconde();
      if (v2.id === v.id) items[0].quantity = 2;
      else items.push({ id: v2.id, quantity: 1 });
    }
    occupe = true;
    var btn = $("[data-os-add]", root);
    var lab = btn && $("[data-os-add-label]", btn);
    if (btn) btn.disabled = true;
    if (lab) lab.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Error"); return j; }); })
      .then(function () {
        var cb = $(".os-cartbtn", root); if (cb) { cb.classList.remove("pop"); void cb.offsetWidth; cb.classList.add("pop"); }
        return ouvrir();
      })
      .catch(function (err) { alert("Sorry — this item could not be added. " + (err && err.message ? err.message : "")); })
      .then(function () { occupe = false; if (btn) btn.disabled = false; majPage(false); });
  }

  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); ajouter(); });
  var sAdd = $("[data-os-sticky-add]", root);
  if (sAdd) sAdd.addEventListener("click", ajouter);

  /* Paiement express : sans taille, le clic est intercepte (voile CSS). */
  var xp = $("[data-os-express]", root);
  if (xp) xp.addEventListener("click", function (e) {
    var manque = tailleManquante();
    if (manque) { e.preventDefault(); e.stopPropagation(); demanderTaille(manque); }
  }, true);

  /* ------------------------------------------------------- barre mobile */
  var sticky = $("[data-os-sticky]", root);
  var cta = $("[data-os-add]", root);
  if (sticky && cta && "IntersectionObserver" in window) {
    var vu = false;
    new IntersectionObserver(function (en) {
      vu = en[0].isIntersecting;
      var on = !vu && !tiroirOuvert;
      sticky.classList.toggle("on", on);
      sticky.setAttribute("aria-hidden", on ? "false" : "true");
      if (sAdd) sAdd.tabIndex = on ? 0 : -1;
    }, { threshold: 0 }).observe(cta);
  }

  /* ------------------------------------------------------ guide tailles */
  var dlg = $("[data-os-sizes-dialog]", root);
  $$("[data-os-open-sizes]", root).forEach(function (b) {
    b.addEventListener("click", function () {
      if (dlg && typeof dlg.showModal === "function") dlg.showModal();
      else { var s = document.getElementById("os-size-guide"); if (s) s.scrollIntoView({ behavior: "smooth" }); }
    });
  });
  if (dlg) {
    $$("[data-os-close-sizes]", dlg).forEach(function (b) { b.addEventListener("click", function () { dlg.close(); }); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* --------------------------------------------------------- livraison */
  $$("[data-os-eta]", root).forEach(function (el) {
    var f = fenetre(el.getAttribute("data-min"), el.getAttribute("data-max"));
    if (f) el.textContent = f + " · " + el.getAttribute("data-min") + "–" + el.getAttribute("data-max") + " business days";
  });

  /* ============================================================= panier */
  var tiroir = $("[data-os-drawer]", root);
  var scrim = $("[data-os-scrim]", root);
  var corps = $("[data-os-dw-body]", root);
  var pied = $("[data-os-dw-foot]", root);
  var wallets = $("[data-os-wallets]", root);
  var tiroirOuvert = false;
  var retour = null;

  function reglage(n, d) { var v = tiroir && tiroir.getAttribute(n); return v === null || v === "" ? d : v; }

  function estCadeau(l) {
    var p = l.properties || {};
    return p._mirthly_free_gift === "true" || p._mirthly_free_gift === true;
  }

  function compte(cart) {
    return (cart.items || []).reduce(function (s, l) { return s + (estCadeau(l) ? 0 : l.quantity); }, 0);
  }

  function majCompteur(cart) {
    var n = compte(cart);
    $$("[data-os-count]", root).forEach(function (e) { e.textContent = String(n); });
    var c = $("[data-os-dw-count]", root); if (c) c.textContent = n ? "(" + n + ")" : "";
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function changer(key, q) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(function (r) { return r.json(); });
  }

  /* Un cadeau ajoute automatiquement pour un calendrier n est jamais facture :
     s il ne passe plus a 0 $ (calendrier retire), on le retire. */
  function nettoyer(cart) {
    var cadeau = (cart.items || []).filter(function (l) { return estCadeau(l) && l.final_line_price > 0; })[0];
    if (!cadeau) return Promise.resolve(cart);
    return changer(cadeau.key, 0).then(getCart);
  }

  function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; }

  function peindre(cart) {
    majCompteur(cart);
    if (!corps || !pied) return;
    var items = cart.items || [];
    if (!items.length) {
      corps.innerHTML = '<div class="os-empty"><h3>Your cart is empty</h3><p>Pick a character and a size to get started.</p></div>';
      pied.innerHTML = '<button type="button" class="os-cta" data-os-keep>Keep shopping</button>';
      $("[data-os-keep]", pied).addEventListener("click", fermer);
      if (wallets) wallets.hidden = true;
      return;
    }

    corps.innerHTML = items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      var gratuit = l.final_line_price === 0 && l.original_line_price > 0;
      var variante = l.variant_title && l.variant_title !== "Default Title" ? l.variant_title : "";
      var offre = (l.line_level_discount_allocations || []).map(function (a) {
        return a.discount_application && a.discount_application.title;
      }).filter(Boolean)[0];
      return '<div class="os-line">' +
        '<div class="os-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : "") + "</div>" +
        "<div>" +
          '<p class="os-line__t">' + esc(l.product_title) + "</p>" +
          (variante ? '<p class="os-line__v">' + esc(variante) + "</p>" : "") +
          (offre && !estCadeau(l) ? '<span class="os-deal">🎁 ' + esc(offre) + "</span>" : "") +
          (estCadeau(l) ? (gratuit ? '<span class="os-free">FREE GIFT</span>' : "") :
            '<span class="os-qty"><button type="button" data-k="' + esc(l.key) + '" data-q="' + (l.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            "<span>" + l.quantity + "</span>" +
            '<button type="button" data-k="' + esc(l.key) + '" data-q="' + (l.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
            '<button type="button" class="os-rm" data-k="' + esc(l.key) + '" data-q="0">Remove</button>') +
        "</div>" +
        '<div class="os-line__p">' + money(l.final_line_price) +
          (l.original_line_price > l.final_line_price ? "<s>" + money(l.original_line_price) + "</s>" : "") +
        "</div>" +
      "</div>";
    }).join("");

    $$("[data-k]", corps).forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.disabled) return;
        $$("[data-k]", corps).forEach(function (x) { x.disabled = true; });
        changer(b.getAttribute("data-k"), parseInt(b.getAttribute("data-q"), 10))
          .then(nettoyer)
          .then(peindre)
          .catch(function () { return rafraichir(); });
      });
    });

    var remise = cart.total_discount || 0;
    var eta = fenetre(reglage("data-eta-min", "7"), reglage("data-eta-max", "14"));
    var html =
      (remise > 0 ? '<div class="os-sum"><span>Savings</span><span class="ok">&minus;' + money(remise) + "</span></div>" : "") +
      '<div class="os-sum"><span>Shipping</span><span class="ok">' + esc(reglage("data-ship", "Free")) + "</span></div>" +
      '<div class="os-sum tot"><span>Total</span><span>' + money(cart.total_price) + "</span></div>" +
      '<a class="os-cta" href="/checkout" data-os-checkout>Secure Checkout &mdash; ' + money(cart.total_price) + ' <span aria-hidden="true">&rarr;</span></a>' +
      (eta ? '<p class="os-meta">📦 ' + esc(reglage("data-eta-label", "Arrives")) + " " + esc(eta) + "</p>" : "") +
      '<div class="os-dw__pay"><span class="os-dw__icons"></span><span>🔒 ' + esc(reglage("data-secure", "Secure checkout")) + "</span></div>";
    pied.innerHTML = html;
    var modele = $("[data-os-pay-icons]", root);
    var ic = $(".os-dw__icons", pied);
    if (modele && modele.content && ic) ic.appendChild(modele.content.cloneNode(true));
    var co = $("[data-os-checkout]", pied);
    if (co) co.addEventListener("click", function () { co.textContent = "Redirecting…"; });

    if (wallets) wallets.hidden = !wallets.children.length;
  }

  function rafraichir() {
    return getCart().then(nettoyer).then(peindre).catch(function () {});
  }

  function ouvrir() {
    retour = document.activeElement;
    tiroirOuvert = true;
    if (sticky) sticky.classList.remove("on");
    tiroir.classList.add("on"); scrim.classList.add("on");
    tiroir.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var x = $("[data-os-close-cart]", tiroir);
    setTimeout(function () { if (x) x.focus(); }, 60);
    return rafraichir();
  }

  function fermer() {
    tiroirOuvert = false;
    tiroir.classList.remove("on"); scrim.classList.remove("on");
    tiroir.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (retour && retour.focus) retour.focus();
  }

  if (tiroir) {
    $$("[data-os-open-cart]", root).forEach(function (b) { b.addEventListener("click", ouvrir); });
    $$("[data-os-close-cart]", root).forEach(function (b) { b.addEventListener("click", fermer); });
    if (scrim) scrim.addEventListener("click", fermer);
    document.addEventListener("keydown", function (e) {
      if (!tiroirOuvert) return;
      if (e.key === "Escape") { fermer(); return; }
      if (e.key !== "Tab") return;
      var f = $$('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])', tiroir)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ------------------------------------------------------------ depart */
  majPage(false);
  if (tailleManquante() && form) form.classList.add("need-size");
  getCart().then(majCompteur).catch(function () {});
})();
